var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("alert alert-" + (_vm.alert.color))},[_c('button',{staticClass:"close",attrs:{"aria-hidden":"true","data-dismiss":"alert","type":"button"}},[_vm._v("×")]),_vm._v(" "),_c('strong',[_c('i',{class:("fa " + (_vm.alert.icon))}),_vm._v(" "+_vm._s(_vm.alert.title))]),_vm._v(" "+_vm._s(_vm.alert.subtitle)+"\n")])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-773976db","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/Assets/components/Users/LoginOrSignup/Alert.vue
// module id = 883
// module chunks = 1 2